import React, {useEffect, useState} from 'react'
import {Layer, Stage} from "react-konva";
import useImage from "use-image";
import ImageItem from "./shapes/image-item";

const initialRectangles = [
    {
        x: 10,
        y: 10,
        width: 100,
        height: 100,
        fill: 'purple',
        id: 'rect1',
    },
    {
        x: 150,
        y: 150,
        width: 100,
        height: 100,
        fill: 'gray',
        id: 'rect2',
    },
];

/*const BackgroundImage = () => {
    const [image] = useImage('assets/images/background/space-splash001.png');
    return <Image
        height={400}
        width={400}
        image={image}/>;
};*/

const initialImageDetail = {
    id: 'image-01',
    height: 400,
    width: 400,
    imageUrl: 'assets/images/background/space-splash001.png'
}

const ImageTransformer = () => {
    const [initialStep, setInitialStep] = useState(true);
    const [rectangles, setRectangles] = React.useState(initialRectangles);
    const [imageDetail, setImageDetail] = React.useState(initialImageDetail);
    const [imageDetailList, setImageDetailList] = React.useState(null);
    const [selectedId, selectShape] = React.useState(null);

    useEffect(() => {
        if (initialStep) {
            getInitialImageDetails();
        }
    }, [initialStep]);

    const getInitialImageDetails = () => {
        // const [image] = useImage('assets/images/background/space-splash001.png');

        const initialImageDetail = [{
            id: 'image-01',
            height: 400,
            width: 400,
            image: 'assets/images/background/space-splash001.png'
        }];

        console.log('initialImageDetail: ', initialImageDetail);
        setImageDetailList(initialImageDetail);
        console.log('imageDetailList: ', imageDetailList);
        // return initialImageDetail;
    };

    const checkDeselect = (event) => {
        console.log('Inside checkDeselect: event.target -> ', event.target);
        console.log('Inside checkDeselect: event.target.getStage() -> ', event.target.getStage());
        // deselect when clicked on empty area
        const clickedOnEmpty = event.target === event.target.getStage();

        console.log('Inside checkDeselect -> ', clickedOnEmpty);
        if (clickedOnEmpty) {
            selectShape(null);
        }
    };

    return (
        <>
            <Stage width={window.innerWidth * 3 / 4} height={window.innerHeight * 3 / 4}
                   onMouseDown={checkDeselect}
                   onTouchStart={checkDeselect}
                   className="">
                <Layer>
                    <ImageItem
                        shapeProps={imageDetail}
                        isSelected={imageDetail.id === selectedId}
                        onSelect={() => {
                            selectShape(imageDetail.id);
                        }}
                        onChange={(newAttrs) => {
                            setImageDetail(newAttrs);
                        }}
                    />
                    {/*{imageDetailList?.map((imageDetail, i) => {
                        return (
                            <ImageItem
                                key={i}
                                shapeProps={imageDetail}
                                isSelected={imageDetail.id === selectedId}
                                onSelect={() => {
                                    selectShape(imageDetail.id);
                                }}
                                onChange={(newAttrs) => {
                                    // setImageDetail(newAttrs);
                                }}
                            />
                        )
                    })}*/}

                    {/*{rectangles.map((rect, i) => {
                        return (
                            <Rectangle
                                key={i}
                                shapeProps={rect}
                                isSelected={rect.id === selectedId}
                                onSelect={() => {
                                    selectShape(rect.id);
                                }}
                                onChange={(newAttrs) => {
                                    const rects = rectangles.slice();
                                    rects[i] = newAttrs;
                                    setRectangles(rects);
                                }}
                            />
                        )
                    })}*/}
                </Layer>
            </Stage>
        </>
    )
}

export default ImageTransformer
